import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

import { stringToColor } from '../../libs/random-color'

const Container = styled.div`
  display: inline-block;
  width: ${(props) => props.fontSize * 2.5}rem;
  height: ${(props) => props.fontSize * 2.5}rem;
  border-radius: 5rem;
  background-color: ${(props) => (props.name ? stringToColor(props.name) : '#aaa')};
  vertical-align: middle;
`

const Name = styled.div`
  vertical-align: middle;
  text-align: center;
`

const constructInitialName = (customerName) =>
  customerName
    .split(' ', 2)
    .map((name) => name && name.charAt(0))
    .join('')
    .toUpperCase()

export const InitialName = ({ name, fontSize = 1.625, className }) => (
  <Container fontSize={fontSize} name={name} className={className}>
    <Name
      className="text-white"
      style={{ fontSize: `${fontSize}rem`, lineHeight: 2.5 }}
      data-robot="feedback-popup-name"
    >
      {name ? constructInitialName(name) : '-'}
    </Name>
  </Container>
)

InitialName.propTypes = {
  name: PropTypes.string,
  fontSize: PropTypes.number,
  className: PropTypes.string,
}

export default InitialName



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/InitialName/index.js